import { api } from '../../../services/api';
import type {
  TemplateTreeResponse,
  TemplateDetail,
  TemplateRecord,
  TemplateVersion,
  GitFileHistoryEntry,
  GitDiffResult,
  AuditLogEntry,
} from '../types/template.types';

const BASE = '/admin/template-studio';

export const templateStudioService = {
  // Templates
  listTemplates: (tenantId: string) =>
    api.get<TemplateTreeResponse>(`${BASE}/${tenantId}/templates`),

  getTemplate: (tenantId: string, templateId: string) =>
    api.get<TemplateDetail>(`${BASE}/${tenantId}/templates/${templateId}`),

  createTemplate: (tenantId: string, data: {
    name: string; fileName: string; templateType: string;
    classification: string; content: string; commitMessage: string;
    subjectLine?: string;
  }) => api.post<TemplateRecord>(`${BASE}/${tenantId}/templates`, data),

  updateContent: (tenantId: string, templateId: string, data: {
    content: string; commitMessage: string;
  }) => api.put<TemplateVersion>(`${BASE}/${tenantId}/templates/${templateId}`, data),

  updateMetadata: (tenantId: string, templateId: string, data: Record<string, unknown>) =>
    api.patch<TemplateRecord>(`${BASE}/${tenantId}/templates/${templateId}/metadata`, data),

  deleteTemplate: (tenantId: string, templateId: string) =>
    api.delete(`${BASE}/${tenantId}/templates/${templateId}`),

  forkTemplate: (tenantId: string, data: { sourceTemplateId: string; name?: string }) =>
    api.post<TemplateRecord>(`${BASE}/${tenantId}/templates/fork`, data),

  activateVersion: (tenantId: string, templateId: string, version: number) =>
    api.post(`${BASE}/${tenantId}/templates/${templateId}/activate/${version}`),

  // Git history & diff
  getHistory: (tenantId: string, templateId: string) =>
    api.get<GitFileHistoryEntry[]>(`${BASE}/${tenantId}/templates/${templateId}/history`),

  getDiff: (tenantId: string, templateId: string, fromSha: string, toSha: string) =>
    api.post<GitDiffResult>(`${BASE}/${tenantId}/templates/${templateId}/diff`, { fromSha, toSha }),

  // Audit
  getAuditLog: (tenantId: string, templateId: string, limit = 50) =>
    api.get<AuditLogEntry[]>(`${BASE}/${tenantId}/templates/${templateId}/audit?limit=${limit}`),

  // Test render
  testRender: (tenantId: string, templateId: string, data: {
    content: string; sampleData: Record<string, unknown>; subjectLine?: string;
  }) => api.post<{ html: string; subject?: string }>(`${BASE}/${tenantId}/templates/${templateId}/test-render`, data),
};
